import { VideoFeedback } from "@/enums/enums";
import { i18n } from "@/i18n";

function GenerateYouTubeVideoURL(videoId: string): string {
  const videoUrl = `https://www.youtube.com/embed/${videoId}?rel=0`;
  return videoUrl;
}
export function GetYoutubeUrlFromPageName(urlName: string) {
  let youtubeUrlList = [];
  const withholding = {
    name: i18n.t("youtube_List.Create_Withholding_Tax"),
    url: GenerateYouTubeVideoURL("pETowXp9_kU"),
    isShow: false,
    isSendFeedback: VideoFeedback.None,
  };
  const createPND1 = {
    name: i18n.t("youtube_List.Create_PND_1"),
    url: GenerateYouTubeVideoURL("TYTAoUxhLoY"),
    isShow: false,
    isSendFeedback: VideoFeedback.None,
  };
  const exportPND1 = {
    name: i18n.t("youtube_List.Export_PND_1"),
    url: GenerateYouTubeVideoURL("jjBvqt_ivlw"),
    isShow: false,
    isSendFeedback: VideoFeedback.None,
  };
  const accountRecordPND1 = {
    name: i18n.t("youtube_List.Account_Record_PND_1"),
    url: GenerateYouTubeVideoURL("jbx7FK-3Dvc"),
    isShow: false,
    isSendFeedback: VideoFeedback.None,
  };
  const createPND2 = {
    name: i18n.t("youtube_List.Create_PND_2"),
    url: GenerateYouTubeVideoURL("1aN58-8-3I4"),
    isShow: false,
    isSendFeedback: VideoFeedback.None,
  };
  const exportPND2 = {
    name: i18n.t("youtube_List.Export_PND_2"),
    url: GenerateYouTubeVideoURL("wfjqcqsLPz0"),
    isShow: false,
    isSendFeedback: VideoFeedback.None,
  };
  const accountRecordPND2 = {
    name: i18n.t("youtube_List.Account_Record_PND_2"),
    url: GenerateYouTubeVideoURL("kB037nWprHI"),
    isShow: false,
    isSendFeedback: VideoFeedback.None,
  };
  const createPND3 = {
    name: i18n.t("youtube_List.Create_PND_3"),
    url: GenerateYouTubeVideoURL("VTp9WYO2M58"),
    isShow: false,
    isSendFeedback: VideoFeedback.None,
  };
  const exportPND3 = {
    name: i18n.t("youtube_List.Export_PND_3"),
    url: GenerateYouTubeVideoURL("sz1Zi1IlUlo"),
    isShow: false,
    isSendFeedback: VideoFeedback.None,
  };
  const accountRecordPND3 = {
    name: i18n.t("youtube_List.Account_Record_PND_3"),
    url: GenerateYouTubeVideoURL("yfEoeS7Sx_8"),
    isShow: false,
    isSendFeedback: VideoFeedback.None,
  };
  const createPND53 = {
    name: i18n.t("youtube_List.Create_PND_53"),
    url: GenerateYouTubeVideoURL("6YDC8RB3CXI"),
    isShow: false,
    isSendFeedback: VideoFeedback.None,
  };
  const exportPND53 = {
    name: i18n.t("youtube_List.Export_PND_53"),
    url: GenerateYouTubeVideoURL("iQ3rZn8k1j4"),
    isShow: false,
    isSendFeedback: VideoFeedback.None,
  };
  const accountRecordPND53 = {
    name: i18n.t("youtube_List.Account_Record_PND_53"),
    url: GenerateYouTubeVideoURL("tWu-b0Z6RjE"),
    isShow: false,
    isSendFeedback: VideoFeedback.None,
  };
  const salesTax = {
    name: i18n.t("youtube_List.Sales_Tax"),
    url: GenerateYouTubeVideoURL("KPwJLMUUoK0"),
    isShow: false,
    isSendFeedback: VideoFeedback.None,
  };
  const purchaseTax = {
    name: i18n.t("youtube_List.Purchase_Tax"),
    url: GenerateYouTubeVideoURL("4tA-kPcY1fU"),
    isShow: false,
    isSendFeedback: VideoFeedback.None,
  };
  const createForm30 = {
    name: i18n.t("youtube_List.Create_Form_30"),
    url: GenerateYouTubeVideoURL("PN2u3gSkWzw"),
    isShow: false,
    isSendFeedback: VideoFeedback.None,
  };
  const saveForm30 = {
    name: i18n.t("youtube_List.Save_Form_30"),
    url: GenerateYouTubeVideoURL("IYsAD6RRIgk"),
    isShow: false,
    isSendFeedback: VideoFeedback.None,
  };
  const settingUser = {
    name: i18n.t("youtube_List.Setting_User"),
    url: GenerateYouTubeVideoURL("qTaPHmw_1tE"),
    isShow: false,
    isSendFeedback: VideoFeedback.None,
  };

  switch (urlName) {
    case "withholding":
      youtubeUrlList = [withholding];
      break;
    case "pnd1":
      youtubeUrlList = [createPND1, exportPND1, accountRecordPND1];
      break;
    case "pnd1Create":
      youtubeUrlList = [createPND1, exportPND1, accountRecordPND1];
      break;
    case "pnd1Detail":
      youtubeUrlList = [createPND1, exportPND1, accountRecordPND1];
      break;
    case "pnd2":
      youtubeUrlList = [createPND2, exportPND2, accountRecordPND2];
      break;
    case "pnd2Create":
      youtubeUrlList = [createPND2, exportPND2, accountRecordPND2];
      break;
    case "pnd2Detail":
      youtubeUrlList = [createPND2, exportPND2, accountRecordPND2];
      break;
    case "pnd3":
      youtubeUrlList = [createPND3, exportPND3, accountRecordPND3];
      break;
    case "pnd3Create":
      youtubeUrlList = [createPND3, exportPND3, accountRecordPND3];
      break;
    case "pnd3Detail":
      youtubeUrlList = [createPND3, exportPND3, accountRecordPND3];
      break;
    case "pnd53":
      youtubeUrlList = [createPND53, exportPND53, accountRecordPND53];
      break;
    case "pnd53Create":
      youtubeUrlList = [createPND53, exportPND53, accountRecordPND53];
      break;
    case "pnd53Detail":
      youtubeUrlList = [createPND53, exportPND53, accountRecordPND53];
      break;
    case "salesVATItem":
      youtubeUrlList = [salesTax];
      break;
    case "salesTaxItemDetail":
      youtubeUrlList = [salesTax];
      break;
    case "purchaseVATItem":
      youtubeUrlList = [purchaseTax];
      break;
    case "purchaseTaxItemDetail":
      youtubeUrlList = [purchaseTax];
      break;
    case "pp30form":
      youtubeUrlList = [createForm30, saveForm30];
      break;
    case "pp30Create":
      youtubeUrlList = [createForm30, saveForm30];
      break;
    case "pp30Detail":
      youtubeUrlList = [createForm30, saveForm30];
      break;
    case "settingMerchant":
      youtubeUrlList = [settingUser];
      break;
    case "settingLogoStamp":
      youtubeUrlList = [settingUser];
      break;
    case "settingConnectPeak":
      youtubeUrlList = [settingUser];
      break;
    case "settingUser":
      youtubeUrlList = [settingUser];
      break;
    default:
      youtubeUrlList = [
        {
          name: i18n.t("youtube_List.Overview"),
          url: GenerateYouTubeVideoURL("zQj25n4uxcI"),
          isShow: false,
          isSendFeedback: VideoFeedback.None,
        },
        {
          name: i18n.t("youtube_List.Setting_Access"),
          url: GenerateYouTubeVideoURL("6OAKMFK4WPI"),
          isShow: false,
          isSendFeedback: VideoFeedback.None,
        },
        {
          name: i18n.t("youtube_List.Retrieve_Data"),
          url: GenerateYouTubeVideoURL("qw9VT0Ob2Ts"),
          isShow: false,
          isSendFeedback: VideoFeedback.None,
        },
      ];
      break;
  }

  return youtubeUrlList;
}
